export default __webpack_public_path__ + "static/media/LOGO_EV_21_TB_42.cba65588.png";